$('.open-map-btn').on('click', function () {
    openMap();
});
$('.close-map-btn').on('click', function () {
    closeMap();
});

// Module-scoped state (no longer polluting window)
let markers = [];
let infoWindows = [];
let selectedArea = null;
let markerCluster = null;
let _clusterModule = null;

/**
 * Lazy-load the MarkerClusterer library only when the map is actually used.
 * Returns a cached reference on subsequent calls.
 */
function loadClusterModule() {
    if (_clusterModule) return Promise.resolve(_clusterModule);
    return import('@googlemaps/markerclusterer').then(mod => {
        _clusterModule = mod;
        return mod;
    });
}

// Custom cluster renderer matching the existing cluster icon styles
const clusterRenderer = {
    render({ count, position }) {
        let iconUrl;
        if (count < 10) {
            iconUrl = '/images/cluster-small.png';
        } else if (count < 100) {
            iconUrl = '/images/cluster-medium.png';
        } else {
            iconUrl = '/images/cluster-big.png';
        }

        return new google.maps.Marker({
            position,
            icon: {
                url: iconUrl,
                scaledSize: new google.maps.Size(66, 66),
            },
            label: {
                text: String(count),
                color: '#ffffff',
                fontSize: '16px',
            },
            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
        });
    }
};

/**
 * Parse area string (e.g. "3m x 4m", "12.5 m2", "20") to a numeric m² value.
 */
function parseAreaToNumber(areaString) {
    if (!areaString || typeof areaString !== 'string') {
        return null;
    }

    const dimensionMatch = areaString.match(/(\d+(?:\.\d+)?)\s*m?\s*x\s*(\d+(?:\.\d+)?)\s*m?/i);
    if (dimensionMatch) {
        return parseFloat(dimensionMatch[1]) * parseFloat(dimensionMatch[2]);
    }

    const areaMatch = areaString.match(/(\d+(?:\.\d+)?)\s*(?:m[²2]?|square\s*meters?)/i);
    if (areaMatch) {
        return parseFloat(areaMatch[1]);
    }

    const numberMatch = areaString.match(/(\d+(?:\.\d+)?)/);
    if (numberMatch) {
        return parseFloat(numberMatch[1]);
    }

    return null;
}

/**
 * Clear all markers, info windows, and the cluster from the map.
 */
function clearMapElements() {
    if (selectedArea) selectedArea.setMap(null);
    selectedArea = null;
    markers.forEach(marker => marker.setMap(null));
    markers = [];

    infoWindows.forEach(iw => iw.close());
    infoWindows = [];

    if (markerCluster) {
        markerCluster.clearMarkers();
        markerCluster = null;
    }
}

/**
 * Group listings by proximity so co-located listings share a single marker.
 */
function groupByProximity(listings) {
    const threshold = 0.0001; // ~11 meters
    const groups = {};

    listings.forEach(listing => {
        if (listing.latitude == null || listing.longitude == null) return;
        const lat = Number(listing.latitude);
        const lng = Number(listing.longitude);
        if (isNaN(lat) || isNaN(lng)) return;

        const key = `${Math.round(lat / threshold) * threshold},${Math.round(lng / threshold) * threshold}`;
        if (!groups[key]) groups[key] = [];
        groups[key].push(listing);
    });

    return groups;
}

/**
 * Build the HTML content for a marker's info window popup.
 */
function buildInfoWindowContent(group) {
    const isMobile = window.innerWidth <= 480;
    const containerMaxWidth = isMobile ? '260px' : '350px';
    const contentWidth = isMobile ? '220px' : '300px';
    const imageHeight = isMobile ? '80px' : '120px';
    const titleSize = isMobile ? '0.95em' : '1.1em';
    const priceSize = isMobile ? '1em' : '1.2em';
    const btnPadding = isMobile ? 'padding: 8px 12px; font-size: 13px;' : '';
    const spacing = isMobile ? '6px' : '10px';
    const maxHeight = isMobile ? '250px' : '300px';
    const containerPadding = isMobile ? '8px' : '10px';

    let html = `<div class="info-window" style="max-height: ${maxHeight}; max-width: ${containerMaxWidth}; overflow-y: ${group.length === 1 ? 'hidden' : 'auto'}; overflow-x: hidden; padding: ${containerPadding}; box-sizing: border-box; text-align: center;">`;

    group.forEach((listing, index) => {
        const title = listing.title || 'Untitled Listing';
        const image = listing.image || '/images/placeholders/indoor.png';
        const price = listing.formattedPrice || 'Price not available';
        const readMoreUrl = listing.routes && listing.routes.readMore ? listing.routes.readMore : '#';

        html += `
            <div style="margin-bottom: ${spacing}; display: inline-block; width: ${contentWidth}; text-align: center;">
                <h5 class="name" style="white-space: normal; word-wrap: break-word; margin: 0 auto ${spacing} auto; width: 100%; font-size: ${titleSize};">${title}</h5>
                ${listing.locationRadius > 0 ? '<p>Approximate location</p>' : ''}
                <div class="xs-mb-20" style="margin-top: ${spacing}; height: ${imageHeight}; overflow: hidden;">
                    <img src="${image}" style="width: 100%; height: 100%; object-fit: cover;">
                </div>
                <div class="row" style="justify-content: center; margin-top: ${spacing};">
                    <h4 class="col-sm-8" style="margin: 0; font-size: ${priceSize};">${price}</h4>
                </div>
                <a class="btn btn-primary" href="${readMoreUrl}" target="_blank" style="display: block; margin-top: ${spacing}; width: 100%; ${btnPadding}">View Listing</a>
            </div>`;

        if (index < group.length - 1) {
            html += `<hr style="border-top: 1px solid #eee; margin: ${spacing} 0;">`;
        }
    });

    html += '</div>';
    return html;
}

/**
 * Populate the map with filtered listing markers and clusters.
 */
window.populateMapWithListings = (mapInstance, typeFilter, currentFilter) => {
    if (!mapInstance) return;

    clearMapElements();

    // Apply filters
    let listingsToShow = window.defaultListings;
    if (!listingsToShow || listingsToShow.length === 0) {
        return;
    }

    if (typeFilter && typeFilter !== 'All') {
        listingsToShow = listingsToShow.filter(listing =>
            listing.features && listing.features.type === typeFilter
        );
    }

    if (currentFilter && currentFilter.min_area) {
        listingsToShow = listingsToShow.filter(listing => {
            const listingArea = listing.area || listing.metadata?.area || (listing.features && listing.features.area);
            if (!listingArea) return false;
            const numericArea = parseAreaToNumber(listingArea);
            if (numericArea === null) return false;
            return numericArea >= currentFilter.min_area;
        });
    }

    if (listingsToShow.length === 0) return;

    // Group nearby listings and create markers
    const grouped = groupByProximity(listingsToShow);

    Object.keys(grouped).forEach(key => {
        const group = grouped[key];
        const lat = Number(group[0].latitude);
        const lng = Number(group[0].longitude);

        if (isNaN(lat) || isNaN(lng)) return;

        const marker = new google.maps.Marker({
            position: { lat, lng },
            title: group.some(listing => listing.locationRadius > 0) ? 'Approximate listing area' : 'Listing location',
            icon: { url: '/images/custom-pin.png' }
        });
        markers.push(marker);

        const infoWindow = new google.maps.InfoWindow({
            content: buildInfoWindowContent(group),
        });
        infoWindows.push(infoWindow);

        marker.addListener('click', () => {
            infoWindows.forEach(iw => iw.close());
            if (selectedArea) selectedArea.setMap(null);
            const radius = Math.max(...group.map(listing => listing.locationRadius || 0));
            selectedArea = radius > 0 ? new google.maps.Circle({
                map: mapInstance, center: {lat, lng}, radius,
                strokeColor: '#ff8551', strokeWeight: 2, fillColor: '#ff8551', fillOpacity: 0.2
            }) : null;
            infoWindow.open(mapInstance, marker);
        });
    });

    // Close info windows on map click
    mapInstance.addListener('click', () => {
        infoWindows.forEach(iw => iw.close());
    });

    // Create cluster with the modern MarkerClusterer (lazy-loaded)
    if (markers.length > 0 && window.map) {
        loadClusterModule().then(({ MarkerClusterer, SuperClusterAlgorithm }) => {
            try {
                markerCluster = new MarkerClusterer({
                    map: mapInstance,
                    markers: markers,
                    algorithm: new SuperClusterAlgorithm({ maxZoom: 14 }),
                    renderer: clusterRenderer,
                });
            } catch (_) {
                // Fallback: add markers directly to the map
                markers.forEach(m => m.setMap(mapInstance));
            }
        }).catch(() => {
            // If dynamic import fails, add markers directly to the map
            markers.forEach(m => m.setMap(mapInstance));
        });
    }
};

window.openMap = (selectedLocation, lat, lng) => {
    $('body').addClass('map-open');
    $('.map-container').removeClass('hidden');

    if (!window.map) {
        initMap();
    }

    // Sync map filters with current listings filter state
    const currentFilter = window.getCurrentListingsFilter ? window.getCurrentListingsFilter() : null;
    if (currentFilter) {
        syncMapFiltersFromListings(currentFilter);
    }

    // Repopulate markers with the current filter
    const selectedType = $('#mapPropertyType').val() || 'All';
    if (window.map) {
        window.populateMapWithListings(window.map, selectedType, currentFilter);
    }

    // Set map center/zoom
    if (window.map && typeof window.map.setCenter === 'function') {
        try {
            if (lat && lng) {
                window.map.setCenter({ lat: parseFloat(lat), lng: parseFloat(lng) });
                window.map.setZoom(12);
            } else {
                window.map.setCenter({ lat: -40.9006, lng: 174.8860 });
                window.map.setZoom(5);
            }
        } catch (_) {
            // Ignore center/zoom errors
        }
    }
};

window.closeMap = () => {
    $('body').removeClass('map-open');
    $('.map-container').addClass('hidden');
};

function initMap() {
    if (window.map) return;

    window.map = new google.maps.Map(document.getElementById('map-wrapper'), {
        zoom: 5,
        scrollwheel: true,
        streetViewControl: false,
        mapTypeControl: false,
        center: { lat: -40.9006, lng: 174.8860 },
        gestureHandling: 'greedy',
    });

    google.maps.event.addListenerOnce(window.map, 'idle', function () {
        initMapFiltersCollapse();

        if (window.defaultListings && window.defaultListings.length > 0) {
            window.populateMapWithListings(window.map);
        }
    });
}

/**
 * Set up collapsible filter panel behaviour.
 */
function initMapFiltersCollapse() {
    const header = document.getElementById('map-filters-header');
    const content = document.getElementById('map-filters-content');
    const chevron = document.getElementById('map-filters-chevron');

    if (!header || !content || !chevron) return;

    content.style.display = 'none';
    chevron.style.transform = 'rotate(0deg)';

    header.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const isCollapsed = content.style.display === 'none';
        content.style.display = isCollapsed ? 'flex' : 'none';
        chevron.style.transform = isCollapsed ? 'rotate(180deg)' : 'rotate(0deg)';
    });

    content.addEventListener('click', function (e) {
        e.stopPropagation();
    });
}

function getCurrentMapFilter() {
    return {
        type: $('#mapPropertyType').val() || 'All',
        min_area: $('#mapMinSize').val() === 'Any' ? null : parseFloat($('#mapMinSize').val())
    };
}

function syncMapFiltersFromListings(listingsFilter) {
    if (!listingsFilter) return;

    if (listingsFilter.type) {
        $('#mapPropertyType').val(listingsFilter.type);
    }

    if (listingsFilter.min_area) {
        const minAreaOptions = ['5', '10', '15', '20', '30', '50'];
        const minAreaValue = parseFloat(listingsFilter.min_area).toString();
        $('#mapMinSize').val(minAreaOptions.includes(minAreaValue) ? minAreaValue : 'Any');
    } else {
        $('#mapMinSize').val('Any');
    }
}

function isMapOpen() {
    return $('body').hasClass('map-open');
}

function updateListingsFromMapFilter(mapFilter) {
    if (window.setListingsFilter) {
        window.setListingsFilter(mapFilter);
    }

    if (window.map) {
        window.populateMapWithListings(window.map, mapFilter.type, mapFilter);
    }
}

$(document).ready(function () {
    // Property Type Filter — only handle when the map overlay is actually open
    $('#mapPropertyType').on('change', function () {
        if (!isMapOpen()) return;

        const mapFilter = getCurrentMapFilter();
        updateListingsFromMapFilter(mapFilter);

        const selectedType = $(this).val();
        const $listingsDropdown = $('#listingsPropertyType');
        if ($listingsDropdown.length && $listingsDropdown.val() !== selectedType) {
            $listingsDropdown.val(selectedType);
            const evt = new Event('change', { bubbles: true });
            $listingsDropdown[0].dispatchEvent(evt);
        }

        if (window.setListingsTypeFilter) {
            window.setListingsTypeFilter(selectedType);
        }
    });

    // Minimum Size Filter — only handle when the map overlay is actually open
    $('#mapMinSize').on('change', function () {
        if (!isMapOpen()) return;

        const mapFilter = getCurrentMapFilter();
        updateListingsFromMapFilter(mapFilter);

        if (window.setListingsMinAreaFilter) {
            window.setListingsMinAreaFilter(mapFilter.min_area);
        }
    });
});
